/* eslint-disable no-unused-vars */
import { Scene, Input, Math as MathPhaser, Geom, Display } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, directionHandler, randomDirection, lightstickHandler, setLastMovement } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import ButtonPressed from "../../phaser/components/buttonPressed";
import SettingsButton from "../../phaser/components/settingsButton";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";

let cursors;
let walls;

let characterSelected;
let enemy;
let objNames = {};
let timeoutDoor = {};
let timeoutTouch = {};
let footsteps;
let hearts = 3;
let totalHearts = 3;
let redHeartsObject = [];
let blackHeartsObject = [];
let gameSettings;
let hasLightstick = false;
let defaultSettings = 1;
let totalTimer = 60;
let speedEnemy = 150;
let numberOfTouch = 0;
let stopEnemy = false;
let instructionsHandler = 0;
let lastCoordenates = null;

const randomPointsEnemy = [
    { x: 3409, y: 1791 },
    { x: 2814, y: 877 },
    { x: 1662, y: 943 },
    { x: 504, y: 671 },
    { x: 2384, y: 383 },
]

export default class Game6 extends Scene {

    constructor() {
        super({ key: "Game6" });
    }
    init(data) {
        characterSelected = data.characterSelected;
        lastCoordenates = data.lastCoordenates;
        hasLightstick = false;
        redHeartsObject = [];
        blackHeartsObject = [];
        hearts = 3;
        this.firstStep = true;
        this.isInRedRoom = false;
        numberOfTouch = 0;
        totalTimer = 60;
        speedEnemy = 100;
        this.events.off('buttonNext-dialogModal');
        this.startAll = false;
        setLastMovement('down');
    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();
    }

    create() {

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }
            this.isPause = true;
            this.startAll = false;
        });

        this.events.on(`resume`, (data, args) => {
            this.isPause = false;
            this.sound.mute = false;
            if (args) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
                if(this.joystickManager) {
                    this.joystickManager.destroyTest();
                    this.joystickManager = null;
                }
                if (args.goHome) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true, lastCoordenates });
                }

                if (args.goStart) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Start`);
                }
            } else {

                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }

                if(hasLightstick) {
                    objNames[characterSelected].anims.play(`lightstick-${characterSelected}-game6`, true);
                    this.showingInstruction = true;
                    this.startAll = false;
                    this.dialogModal._createImageDialog(this, 'dialog-win');

                    this.dialogModal.setText("Got it!".toUpperCase(), `${characterSelected}-hallway`, false, false);
                    

                    clearInterval(this.countdown);
                } else {
                    gameSettings = localStorage.getItem('sound');
                    if (gameSettings === '0') {
                        if (this.ppalSong.isPlaying) {
                            this.ppalSong.stop()
                        }
                    } else {
                        if (!this.ppalSong.isPlaying) {
                            this.ppalSong.play();
                        }
                    }
    
                }
            }
            
        });

        this.cameras.main.setBounds(0, 0, 3801);
        this.physics.world.setBounds(0, 0, 3801);

        this.ppalSong = this.sound.add(`piriSong`, { loop: true, volume: 0.2 });

        this.map = mapHandler(this, 'game6', false, 8, 8);

        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2, volume: 0.2 });

        this.playing = false;
        walls = this.map.walls;
        walls.setScale(3);
        this.map.ground.setScale(3);

        const tilesetFullMap = this.map.map.addTilesetImage('game-6-complete', `tilesgame6_complete`, 8, 8);
        this.fullGround = this.map.map.createLayer('FullGround', tilesetFullMap, 0, 0);
        this.fullGround.setCollisionByProperty({ collides: true });
        this.fullGround.setScale(3);
        this.fullGround.active = false;
        this.fullGround.visible = false;

        this.fullWalls = this.map.map.createLayer('FullWalls', tilesetFullMap, 0, 0);
        this.fullWalls.setCollisionByProperty({ collides: true });
        this.fullWalls.setScale(3);
        this.fullWalls.active = false;
        this.fullWalls.visible = false;


        this.object = this.map.map.createLayer('Objects', tilesetFullMap, 0, 0);
        this.object.setCollisionByProperty({ collides: true });
        this.object.setScale(3);
        this.object.active = false;
        this.object.visible = false;

        this.detonante = this.map.map.createLayer('DetonanteStop', this.map.tileset, 0, 0);
        this.detonante.setCollisionByProperty({ collides: true });
        this.detonante.setScale(3);


        objNames[characterSelected] = this.physics.add.sprite(1630, 2201, `${characterSelected}-game6`, 4);
        objNames[characterSelected].setScale(2.5);
        objNames[characterSelected].setImmovable();
        // objNames[characterSelected].setBounce(1);

        this.add.graphics()
            .lineStyle(5, 0x00ffff, 0.5)

        const itemRandom = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];

        enemy = this.physics.add.sprite(itemRandom.x, itemRandom.y, `${characterSelected}2-game6`);
        enemy.setImmovable();
        enemy.setScale(2.5);
        // enemy.setBounce(1);
        enemy.active = false;
        enemy.visible = false;

        this.deadSprite = this.physics.add.sprite(1622, 2051, `humo-game6`).setScale(2.5).setVisible(false);
        this.anims.create({
            key: `deadSpriteAnimation`,
            frames: this.anims.generateFrameNumbers('humo-game6', { start: 0, end: 16 }),
            frameRate: 7,
            repeat: -1
        });

        walkAnimation(this, `${characterSelected}-game6`);
        reposeAnimation(this, `${characterSelected}-game6`);
        turnStaticAnimation(this, `${characterSelected}-game6`);
        upStaticAnimation(this, `${characterSelected}-game6`);
        leftStaticAnimation(this, `${characterSelected}-game6`);
        rightStaticAnimation(this, `${characterSelected}-game6`);
        backStaticAnimation(this, `${characterSelected}-game6`);
        lightstickAnimation(this, `${characterSelected}-game6`);

        walkAnimation(this, `${characterSelected}2-game6`);
        reposeAnimation(this, `${characterSelected}2-game6`);
        turnStaticAnimation(this, `${characterSelected}2-game6`);
        upStaticAnimation(this, `${characterSelected}2-game6`);
        leftStaticAnimation(this, `${characterSelected}2-game6`);
        rightStaticAnimation(this, `${characterSelected}2-game6`);
        backStaticAnimation(this, `${characterSelected}2-game6`);
        lightstickAnimation(this, `${characterSelected}2-game6`);

        this.countdownText = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 60, 16, 'pixelfont',`${totalTimer} SEG`.toUpperCase(), 10, 1).setTint(0xFFFFFF).setDepth(1).setOrigin(1, 0).setScrollFactor(0).setScale(1.5);
        this.countdownText.visible = false;


        this.collidesWalls = this.physics.add.collider(objNames[characterSelected], walls);
        this.physics.add.collider(objNames[characterSelected], this.fullWalls);
        this.physics.add.collider(enemy, this.fullWalls, () => {
            randomDirection(`${characterSelected}2-game6`);
        }, null, this);

        this.physics.add.collider(enemy, objNames[characterSelected]);

        this.collidesDetonante = this.physics.add.collider(objNames[characterSelected], this.detonante, () => {

            if (this.detonante.active) {

                this.textHoldOn.setPosition(this.screenCenterX, this.screenCenterY + 15);
            this.textHoldOn.visible = true;

                clearTimeout(timeoutDoor);
                timeoutDoor = setTimeout(() => {
                    this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                        if (progress === 1) {
                            this.alreadyTouch = true;
                            if (gameSettings === '1') {
                                this.ppalSong.play();
                            }

                            objNames[characterSelected].setPosition(1638, 1866);
                            this.physics.world.removeCollider(this.collidesDetonante);
                            this.detonante.active = false;
                            this.detonante.visible = false;
                            this.textHoldOn.visible = false;

                            this.physics.world.removeCollider(this.collidesWalls);
                            walls.active = false;
                            walls.visible = false;
                            this.map.ground.active = false;
                            this.map.ground.visible = false;
                            this.fullGround.active = true;
                            this.fullGround.visible = true;
                            this.fullWalls.active = true;
                            this.fullWalls.visible = true;
                            enemy.active = true;
                            enemy.visible = true;
                            this.object.active = true;
                            this.object.visible = true;
                            setLastMovement('down');
                            objNames[characterSelected].anims.play(`repose-${characterSelected}-game6`);
                            // this.dialogModal._createWindow(this, 'dialog-detonante', null, true);
                            this.dialogModal._createImageDialog(this, 'dialog-detonante');
                            this.showingInstruction = true;

                            this.dialogModal.setText("I feel confused, the room suddenly transformed. \nWait a minute! I think I just saw someone who looks exactly \nlike me, dressed in white. \nI need to find the other `me`.".toUpperCase(),
                            `${characterSelected}-hallway`, false, false)
                            this.startAll = false;
                            this.cameras.main.fadeIn();

                        }
                    });

                }, 1000);

            }


        }, null, this);

        this.physics.add.collider(objNames[characterSelected], enemy, () => {
            this.deadSprite.setPosition(enemy.x, enemy.y);
            this.showingInstruction = true;
            this.deadSprite.visible = true;
            this.deadSprite.anims.play(`deadSpriteAnimation`, true);
            let itemRandom2 = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];
            while (itemRandom === itemRandom2) {
                itemRandom2 = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];
            }
            enemy.setPosition(itemRandom2.x, itemRandom2.y);
            stopEnemy = true;
            enemy.setVelocity(0, 0);
            enemy.anims.play(`repose-${characterSelected}2-game6`, true);
            clearTimeout(timeoutTouch);
            timeoutTouch = setTimeout(() => {
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
            this.deadSprite.visible = false;

                    if (progress === 1) {
                        objNames[characterSelected].setPosition(1630, 2201);
                        numberOfTouch++;

                        this.startAll = false;
                        objNames[characterSelected].setVelocity(0, 0);
                        objNames[characterSelected].anims.play(`repose-${characterSelected}-game6`);
                        
                        if (numberOfTouch < 3) {
                            this.pauseTimer = true;

                            // this.dialogModal._createWindow(this, 'dialog-retry', null, true)
                            this.dialogModal._createImageDialog(this, 'dialog-retry');

                            if(numberOfTouch === 1) {
    
                                this.dialogModal.setText("Oh no, where did she go? \nI saw someone identical to me, but it wasn't me. She has a lightstick, \nI need to take it back before she disappears!".toUpperCase(), 
                                `${characterSelected}-hallway`, false, false);
                                
                            } else {
                                this.dialogModal.setText("I need to take it back before she disappears! \n(Press the space bar/action button to take the \nlightstick before your clone disappears)".toUpperCase(), 
                                `${characterSelected}-hallway`, false, false);
                                
                            }



                        } else {
                            // this.dialogModal._createWindow(this, 'dialog-win', null, true)
                            hasLightstick = true;
                            if(this.isMobile) {
                                this.joystickManager.setLightStickValue(hasLightstick);
                            }
                            objNames[characterSelected].anims.play(`lightstick-${characterSelected}-game6`, true);
                            this.dialogModal._createImageDialog(this, 'dialog-win');

                            this.dialogModal.setText("Got it!".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            

                            clearInterval(this.countdown);

                        }
                        this.cameras.main.fadeIn();

                    }
                });

            }, 1000);

        }, null, this);


        this.physics.add.collider(objNames[characterSelected], this.object);
        this.physics.add.collider(enemy, this.object, () => {
            randomDirection(`${characterSelected}2-game6`);
        }, null, this);


        this.time.addEvent({
            delay: 3000,
            callback: () => {
                randomDirection(`${characterSelected}2-game6`);
            },
            loop: true
        })

        this.time.addEvent({
            delay: 10000,
            callback: () => {
                if (speedEnemy < 300) {
                    speedEnemy += 20;
                }
            },
            loop: true
        })

        this.cameras.main.startFollow(objNames[characterSelected], true);

        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);

        window.addEventListener("blur", () => {
            this.isPause = true;
            this.buttonPause.pauseByEvent();
         });
     
        //  document.addEventListener('visibilitychange', () => {
        //      if (document.visibilityState !== 'visible') {
        //          this.buttonPause.pauseByEvent();
        //  } 
        //  });

        objNames[characterSelected].anims.play(`repose-${characterSelected}-game6`);
        // this.dialogModal._createWindow(this, 'first-dialog', null, true);
        this.showingInstruction = true;
        this.dialogModal._createImageDialog(this, 'first-dialog');

        this.dialogModal.setText("It seems like this room is empty... \nMaybe I should check what's on that chair.".toUpperCase(), `${characterSelected}-hallway`, false, false)

        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            let itemRandom2 = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];
            let total = JSON.parse(localStorage.getItem('noL'));

            switch (data.id) {
                case 'first-dialog':
                    if (instructionsHandler === 1) {
                        this.dialogModal.close();
                        instructionsHandler = 0;
                        this.startAll = true;
                        this.showingInstruction = false;
                        if(this.isMobile) {
                            this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game6`, 300);
                            this.joystickManager.createJoystick();
                            this.joystickManager.activate(hasLightstick);
                        }
                    }
                    break;
                case 'dialog-detonante':
                    if (instructionsHandler === 1) {
                        this.dialogModal.close();
                        instructionsHandler = 0;
                        this.countdownText.visible = true;
                        this.startAll = true;
                        this.showingInstruction = false;

                        // objNames[characterSelected].active = true;
                        this.countdown = setInterval(() => {
                            if (!this.isPause && !this.pauseTimer) {
                                totalTimer--;
                            }

                            if (totalTimer <= 0) {
                                clearInterval(this.countdown);
                                this.updateCounter();
                            }
                        }, 1000);
                    }
                    break;
                case 'dialog-retry':
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    while (itemRandom === itemRandom2) {
                        itemRandom2 = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];
                    }

                    enemy.setPosition(itemRandom.x, itemRandom.y);
                    stopEnemy = false;
                    randomDirection(`${characterSelected}2-game6`);
                    this.startAll = true;
                    this.pauseTimer = false;
                    this.showingInstruction = false;

                    // objNames[characterSelected].active = true;
                    break;
                case 'dialog-win':
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    if (total) {
                        if (!total.includes(6)) {
                            total.push(6);
                            localStorage.setItem('noL', JSON.stringify(total));

                        }
                    } else {
                        localStorage.setItem('noL', JSON.stringify([6]));
                    }

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                    }

                    this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                        if (progress === 1) {
                            footsteps.stop();
                            this.ppalSong.stop();
                            this.scene.stop();
                            this.events.off('buttonNext-dialogModal');

                            this.scene.start(`Win`, { characterSelected: characterSelected, level: 6, lastCoordenates });
                        }
                    });
                    break;
            }

        }, this);

        if (this.isMobile) {
            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        let x = 0;
        let y = 16;
        for (let i = 0; i < totalHearts; i++) {
            if (i === 0) {
                x += 40;
            } else {
                x += 30;
            }
            blackHeartsObject.push(this.add.image(x, y, `heartBlack`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
            redHeartsObject.push(this.add.image(x, y, `heartRed`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
        }

        this.lightstickCounter = new LightstickCounter(this);

        this.textHoldOn = this.add.bitmapText(0, 20, 
            'pixelfont', "Hold On . . .".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);

        this.screenCenterX = (this.cameras.main.worldView.x + this.cameras.main.width / 2) + 50;
        this.screenCenterY = this.cameras.main.worldView.y;

    }

    updateCounter() {
        this.tweens.add({
            targets: redHeartsObject[hearts - 1],
            alpha: 0,
            scaleX: 0,
            scaleY: 0,
            ease: 'Linear',
            duration: 200
        });

        var heartsTimeline = this.tweens.createTimeline();

        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 1.5,
            scaleY: 1.5,
            ease: 'Power1',
            duration: 200
        });

        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 3,
            scaleY: 3,
            ease: 'Power1',
            duration: 200
        });
        heartsTimeline.play();
        hearts -= 1;
        setTimeout(() => {
            if (hearts <= 0) {
                if(this.joystickManager) {
                    this.joystickManager.destroyTest();
                    this.joystickManager = null;
                }
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        clearInterval(this.countdown);
                        footsteps.stop();
                        this.ppalSong.stop();
                        this.scene.stop();
                        this.events.off('buttonNext-dialogModal');
                        this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 6, lastCoordenates });
                    }
                });
            }

            objNames[characterSelected].clearTint();
            objNames[characterSelected].alpha = 1;
            totalTimer = 60;
            this.countdown = setInterval(() => {

                totalTimer--;
                if (totalTimer <= 0) {
                    clearInterval(this.countdown);
                    this.updateCounter();
                }
            }, 1000);

        }, 1000);

    }


    update() {


        if (this.startAll) {
            if (!this.isMobile) {
                walkHandler(cursors, objNames[characterSelected], 300, `${characterSelected}-game6`, hasLightstick);
            } else {
                if(this.joystickManager) {

                    this.joystickManager.show();
                }
            }

            if (this.countdownText.visible) {
                this.countdownText.setText(`${totalTimer} SEG`);
            }

            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {

                        footsteps.play();
                        this.playing = true;
                    }
                }

            } else {
                this.playing = false;
                footsteps.stop();
            }

            if (enemy.active && !stopEnemy) {
                directionHandler(enemy, speedEnemy, `${characterSelected}2-game6`);
            }

        }else {
            if(this.isMobile) {
                if(this.joystickManager) {
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game6`);
                    this.joystickManager.pause();
                }
            }
        }



    }

}